module.exports = __webpack_public_path__ + "static/media/monitoring.bf0113c0.svg";